import {NoteScores} from "../../models/scorer/NoteScores";

const noteScorerColors: { [key: number]: string} = {
  [NoteScores.incorrect]: `#FF3934`,
  [NoteScores.correct]: `#3AB517`,
  [NoteScores.close]: `#FFC5B7`,
};

export default noteScorerColors;